import { createSelector } from '@reduxjs/toolkit';
import { ELandStatusType } from '../../../../packages/JsonQuery';
import { selectLandStatus } from 'shared/selectors/jsonQuery';

const OPTIONS = [
  { label: 'Неважно', value: null },
  { label: 'ИЖС', value: ELandStatusType.IndividualHousingConstruction },
  { label: 'Садоводство', value: ELandStatusType.Gardening },
  { label: 'ДНП', value: ELandStatusType.CountryhouseNonCommercialPartnership },
  { label: 'Личное подсобное хозяйство', value: ELandStatusType.PrivateFarm },
  { label: 'Фермерское хозяйство', value: ELandStatusType.Farm },
  { label: 'Земля промназначения', value: ELandStatusType.IndustrialLand },
];

export const selectLandStatusFilter = createSelector(selectLandStatus, value => ({
  label: 'Статус участка',
  value: value?.length ? (value as ELandStatusType[]) : [null],
  options: OPTIONS,
}));
